import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bq0taftdqh: FaireBrandEntity = {
  token: "b_bq0taftdqh",
  type: "brand",
  name: "Stroller Society",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f4212e90fed63e87d31ff04399511c5edc6882b14a666a67b375ce158f7112f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5e72327b327c69fbb63a8cbb91b873cfbbbc82dbec652586a29d8c2f90f75ffe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8f4212e90fed63e87d31ff04399511c5edc6882b14a666a67b375ce158f7112f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5e72327b327c69fbb63a8cbb91b873cfbbbc82dbec652586a29d8c2f90f75ffe.jpeg",
  location: "Villanova, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 256,
  isTopShop: true,
  isInsider: true,
  description:
    'Thanks for stopping by! I am Miranda, founder of Stroller Society. I am a wife and Mom of three young children. I have worked in the Finance industry since graduating college and have always desired to start my own business, especially after watching Shark Tank! While expecting my first child, I had a difficult time finding the perfect "coming home outfit" so I decided to create one. Since launching in 2017, our collection has expanded to include baby outfits, baby gowns, swaddle blankets, accessories and more. I spent a lot of time researching fabrics and materials in order to create high quality, functional, baby-friendly products.  After using these products for my own infants, I\'m confident other parents will love them just as much as I do. \n\nWe aim to bring adorable baby apparel and accessories to customers at a reasonable price point. Please follow us on Instagram and Facebook to stay up to date with new products. We are always looking for Stroller Society brand ambassadors. Kindly share pictures with #stollersociety and tag @strollersociety to be featured!',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:27.283Z",
    importedBy: "entity-db-cli",
  },
};
